export interface Dimension {
  id: string;
  name: string;
}

export interface Attribute {
  id: string;
  dimensionId: string;
  value: string;
  description: string;
}

export interface ProductDetails {
  id: string;
  type: 'charge-station' | 'powerbank';
  model: string;
  description: string;
  name: string;
  image: string;
  price: number;
  currency: string;
  socialProofImages: string[];
  recommendedProductIds: string[];
  variants?: Variant[];
}

export interface Variant {
  variantId: string;
  image?: string;
  attributeIds?: string[];
}

export type ProductVariant = ProductDetails & Variant;

export const allDimensions: Dimension[] = [{ id: 'color', name: 'Color' }];
export const allAttributes: Attribute[] = [
  { id: 'white', dimensionId: 'color', value: '#FFFFFF', description: 'White' },
  { id: 'black', dimensionId: 'color', value: '#000000', description: 'Black' },
];

export const getAttributeDescription = (attributeId: string) => {
  return allAttributes.find((attribute) => attribute.id === attributeId)?.description;
};

export const productCatalog: ProductDetails[] = [
  {
    id: '132',
    name: '5-slot charge station',
    model: 'CMini',
    description:
      '5-slot charge station. Blah blah blah blah Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo. Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit, sed quia consequuntur magni dolores eos qui ratione voluptatem sequi nesciunt. Neque porro quisquam est',
    image: '/images/charge-station-mini-min.png',
    price: 300,
    currency: 'GHS',
    type: 'charge-station',
    socialProofImages: ['/images/mini-in-restaurant-min.png'],
    recommendedProductIds: ['133', '134', '135'],
    variants: [
      {
        variantId: '132-white',
        image: '/images/charge-station-mini-min.png',
        attributeIds: ['white'],
      },
      {
        variantId: '132-black',
        image: '/images/charge-station-mini-black-min.png',
        attributeIds: ['black'],
      },
    ],
  },
  {
    id: '133',
    name: '12-slot charge station',
    model: 'CMax',
    description:
      '12-slot charge station. Blah blah blah blah Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo. Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit, sed quia consequuntur magni dolores eos qui ratione voluptatem sequi nesciunt. Neque porro quisquam est',
    image: '/images/charge-station-max-min.png',
    price: 300,
    currency: 'GHS',
    type: 'charge-station',
    socialProofImages: ['/images/max-in-restaurant-min.png'],
    recommendedProductIds: ['132', '134', '135'],
    variants: [
      {
        variantId: '133-white',
        attributeIds: ['white'],
        image: '/images/charge-station-max-min.png',
      },
      {
        variantId: '133-black',
        attributeIds: ['black'],
        image: '/images/charge-station-max-black-min.png',
      },
    ],
  },
  {
    id: '134',
    name: '20-slot charge station',
    image: '/images/charge-station-mega-min.png',
    model: 'CMega',
    description:
      '20-slot charge station. Blah blah blah blah Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo. Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit, sed quia consequuntur magni dolores eos qui ratione voluptatem sequi nesciunt. Neque porro quisquam est',
    price: 800,
    currency: 'GHS',
    type: 'charge-station',
    socialProofImages: ['/images/mega-in-hotel-lobby-min.png'],
    recommendedProductIds: ['132', '133', '135'],
    variants: [
      {
        variantId: '134-white',
        attributeIds: ['white'],
        image: '/images/charge-station-mega-min.png',
      },
      {
        variantId: '134-black',
        attributeIds: ['black'],
        image: '/images/charge-station-mega-black-min.png',
      },
    ],
  },
  {
    id: '135',
    name: '40-slot charge station',
    image: '/images/charge-station-ultra-min.png',
    model: 'CUltra',
    description:
      '40-slot charge station. Blah blah blah blah Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo. Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit, sed quia consequuntur magni dolores eos qui ratione voluptatem sequi nesciunt. Neque porro quisquam est',
    price: 1500,
    currency: 'GHS',
    type: 'charge-station',
    socialProofImages: ['/images/ultra-next-vending-machine-min.png'],
    recommendedProductIds: ['132', '133', '134'],
    variants: [
      {
        variantId: '135-white',
        attributeIds: ['white'],
        image: '/images/charge-station-ultra-min.png',
      },
      {
        variantId: '135-black',
        attributeIds: ['black'],
        image: '/images/charge-station-ultra-black-min.png',
      },
    ],
  },
  {
    id: '136',
    name: 'Powerbank',
    image: '/images/powerbank-white-min.png',
    model: 'ModelX',
    description:
      'Powerbank. Blah blah blah blah Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo. Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit, sed quia consequuntur magni dolores eos qui ratione voluptatem sequi nesciunt. Neque porro quisquam est',
    price: 100,
    type: 'powerbank',
    currency: 'GHS',
    socialProofImages: ['/images/person-using-powerbank-min.png'],
    recommendedProductIds: ['132', '133', '134', '135'],
    variants: [
      {
        variantId: '136-white',
        attributeIds: ['white'],
      },
    ],
  },
];

export function expand(products: ProductDetails[]): ProductVariant[] {
  return products.flatMap((product) => {
    return (product.variants ?? []).map((variant) => {
      return {
        ...product,
        ...variant,
        id: variant.variantId,
        image: variant.image ?? product.image,
        recommendedProductIds: (product.recommendedProductIds ?? []).map(
          (id) => `${id}-${variant.attributeIds?.join('-')}`,
        ),
      };
    });
  });
}

export const allProducts = expand(productCatalog);

export interface Range {
  id: string;
  min?: number;
  max?: number;
  label: string;
}

export const allPriceRanges: Range[] = [
  { id: 'under-100', max: 100, label: 'Under 100' },
  { id: '2', min: 100, max: 200, label: 'GHS100 - GHS200' },
  { id: 'ghs200-ghs300', min: 200, max: 300, label: 'GHS200 - GHS300' },
  { id: 'ghs300-ghs400', min: 300, max: 400, label: 'GHS300 - GHS400' },
  { id: 'above-ghs400', min: 400, label: 'Above GHS400' },
];

export type CommodityCategory = 'agriculture' | 'construction' | 'metals' | 'energy';
export const COMMODITY_CATEGORY_BG_GRADIENTS: Record<CommodityCategory, string> = {
  agriculture: 'linear-gradient(rgba(131, 204, 255, 0.16) 0%, rgba(131, 204, 255, 0) 100%)',
  construction: 'linear-gradient(rgba(248, 56, 8, 0.18) 0%, rgba(248, 56, 8, 0) 50%)',
  metals:
    'linear-gradient(rgba(255, 253, 131, 0.16) 0%, rgba(255, 253, 131, 0) 100%), rgb(245, 245, 247)',
  energy:
    'linear-gradient(rgba(131, 255, 176, 0.16) 0%, rgba(131, 255, 176, 0) 100%), rgb(245, 245, 247)',
};

export interface Commodity {
  id: string;
  name: string;
  ticker: string;
  price: number;
  image: string;
  category: CommodityCategory;
  bgGradient?: string;
}

export const allCommodities: Commodity[] = [
  {
    id: '1',
    name: 'Cocoa',
    ticker: 'CCOA',
    price: 1000,
    image: '/images/commodities/cocoa-min.png',
    category: 'agriculture',
  },
  {
    id: '2',
    name: 'Cassava',
    ticker: 'SAVA',
    price: 2000,
    image: '/images/commodities/cassava-min.png',
    category: 'agriculture',
  },
  {
    id: '3',
    name: 'Cashew',
    ticker: 'CASH',
    price: 3000,
    image: '/images/commodities/cashew-min.png',
    category: 'agriculture',
  },
  {
    id: '4',
    name: 'Sorghum',
    ticker: 'SORG',
    price: 4000,
    image: '/images/commodities/sorghum-min.png',
    category: 'agriculture',
  },
  {
    id: '5',
    name: 'Maize',
    ticker: 'MAIZE',
    price: 5000,
    image: '/images/commodities/maize-min.png',
    category: 'agriculture',
  },
  {
    id: '6',
    name: 'Soybeans',
    ticker: 'SOYB',
    price: 6000,
    image: '/images/commodities/soya-min.png',
    category: 'agriculture',
  },
  {
    id: '7',
    name: 'Millet',
    ticker: 'MLET',
    price: 7000,
    image: '/images/commodities/millet-min.png',
    category: 'agriculture',
  },
  {
    id: '8',
    name: 'Rice',
    ticker: 'RICE',
    price: 8000,
    image: '/images/commodities/rice-min.png',
    category: 'agriculture',
  },
  {
    id: '9',
    name: 'Shea Butter',
    ticker: 'SHEABTR',
    price: 9000,
    image: '/images/commodities/sheabutter-min.png',
    category: 'agriculture',
  },
  {
    id: '10',
    name: 'Shea Nuts',
    ticker: 'SHEANTS',
    price: 10000,
    image: '/images/commodities/sheanuts-min.png',
    category: 'agriculture',
  },
  {
    id: '11',
    name: 'Solid concrete block',
    ticker: 'SBLK',
    price: 11000,
    image: '/images/commodities/solid-concrete-block-min.png',
    category: 'construction',
  },
  {
    id: '12',
    name: 'Hollow concrete block',
    ticker: 'HBLK',
    price: 12000,
    image: '/images/commodities/hollow-concrete-block-min.png',
    category: 'construction',
  },
  {
    id: '13',
    name: 'Brick',
    ticker: 'BRICK',
    price: 12000,
    image: '/images/commodities/brick-min.png',
    category: 'construction',
  },
  {
    id: '14',
    name: 'Iron rod',
    ticker: 'IROD',
    price: 13000,
    image: '/images/commodities/iron-rods-min.png',
    category: 'construction',
  },
  {
    id: '15',
    name: 'Sugar cane fiber',
    ticker: 'SUFBER',
    price: 14000,
    image: '/images/commodities/sugarcane-fiber-min.png',
    category: 'construction',
  },
  {
    id: '16',
    name: 'Coconut fiber',
    ticker: 'COFBER',
    price: 15000,
    image: '/images/commodities/coconut-fiber-min.png',
    category: 'construction',
  },
];

// A procurement target: either a market commodity (carries ticker/image) or a
// plain catalog/freeform item identified by name only.
export interface ProcurementItem {
  id: string;
  name: string;
  ticker?: string;
  image?: string;
}

export interface ProcurementCatalogGroup {
  category: string;
  items: { id: string; name: string }[];
}

// Procurement can target our market commodities or a broader catalog of goods,
// grouped by category and searchable; freeform entries are also allowed.
export const PROCUREMENT_CATALOG: ProcurementCatalogGroup[] = [
  { category: 'Commodities', items: allCommodities.map((c) => ({ id: c.id, name: c.name })) },
  {
    category: 'Vehicles',
    items: [
      { id: 'veh-car', name: 'Car' },
      { id: 'veh-motorbike', name: 'Motor bikes' },
      { id: 'veh-rickshaw', name: 'Rickshaw' },
      { id: 'veh-car-parts', name: 'Car parts' },
    ],
  },
  {
    category: 'Renewables',
    items: [
      { id: 'ren-solar-fans', name: 'Solar fans' },
      { id: 'ren-solar-lights', name: 'Solar lights' },
      { id: 'ren-power-banks', name: 'Power banks' },
      { id: 'ren-power-stations', name: 'Power stations' },
      { id: 'ren-solar-panels', name: 'Solar panels' },
      { id: 'ren-solar-stations', name: 'Solar stations' },
    ],
  },
  {
    category: 'Building materials',
    items: [
      { id: 'bld-interior-decor', name: 'Interior decor' },
      { id: 'bld-furniture', name: 'Furniture' },
      { id: 'bld-lamps', name: 'Lamps' },
      { id: 'bld-lighting-fixtures', name: 'Lighting fixtures' },
      { id: 'bld-sofas', name: 'Sofas' },
      { id: 'bld-beds', name: 'Beds' },
      { id: 'bld-wardrobe', name: 'Wardrobe' },
      { id: 'bld-cabinets', name: 'Cabinets' },
      { id: 'bld-ceramics', name: 'Ceramics (basins, toilet seats, tiles)' },
    ],
  },
  {
    category: 'Clothing',
    items: [
      { id: 'clo-kids', name: 'Kids clothes' },
      { id: 'clo-male', name: 'Male clothes' },
      { id: 'clo-female', name: 'Female clothes' },
      { id: 'clo-fabrics', name: 'Fabrics' },
    ],
  },
];

const commodityById = new Map(allCommodities.map((c) => [c.id, c]));

// Resolve a selected id (and optional freeform label) to a procurement item,
// preferring the full commodity record when the id is a market commodity.
export const findProcurementItem = (id: string, label?: string): ProcurementItem => {
  const commodity = commodityById.get(id);
  if (commodity != null) {
    return { id: commodity.id, name: commodity.name, ticker: commodity.ticker, image: commodity.image };
  }
  for (const group of PROCUREMENT_CATALOG) {
    const item = group.items.find((entry) => entry.id === id);
    if (item != null) {
      return { id: item.id, name: item.name };
    }
  }
  return { id, name: label ?? id };
};

export type ContractPosition = 'BUYER' | 'SELLER';
export type ContractStatus = 'PENDING' | 'ACTIVE' | 'EXPIRED';
export type ContractType = 'firm' | 'soft';
export interface Contract {
  id: string;
  commodityId: string;
  contractType: ContractType;
  buyerName: string;
  forwardPrice: number;
  status: ContractStatus;
  settlementDate: string;
  contractSize: number;
  fillPercentage: number;
  position?: ContractPosition;
  commitment?: string;
  hedgePct: number;
  requiredDeposit: number;
  createdBy: string;
  createdAt: string;
}

export const allContracts: Contract[] = [
  {
    id: '1',
    commodityId: '1',
    contractType: 'firm',
    status: 'ACTIVE',
    buyerName: 'ABC Distillery',
    forwardPrice: 1000,
    settlementDate: '2026-01-01',
    contractSize: 1000,
    fillPercentage: 50,
    position: 'BUYER',
    commitment: '1000 kg',
    hedgePct: 10,
    requiredDeposit: 1000,
    createdBy: 'Kwame Doe',
    createdAt: 'Today, 10:00 AM',
  },
  {
    id: '2',
    commodityId: '2',
    contractType: 'soft',
    status: 'PENDING',
    buyerName: 'XYZ Industries',
    forwardPrice: 1500,
    settlementDate: '2026-01-01',
    position: 'SELLER',
    contractSize: 10009,
    fillPercentage: 10,
    hedgePct: 15,
    requiredDeposit: 1000,
    createdBy: 'Esi Doe',
    createdAt: 'Today, 10:00 AM',
  },
  {
    id: '3',
    commodityId: '3',
    contractType: 'firm',
    status: 'EXPIRED',
    buyerName: 'JKL Enterprises',
    forwardPrice: 2000,
    settlementDate: '2026-01-01',
    contractSize: 1000,
    position: 'BUYER',
    fillPercentage: 10,
    hedgePct: 15,
    requiredDeposit: 1000,
    createdBy: 'Mabel Adedze',
    createdAt: 'Today, 10:00 AM',
  },
  {
    id: '4',
    commodityId: '5',
    contractType: 'soft',
    status: 'PENDING',
    buyerName: 'Golden Star Foods',
    forwardPrice: 800,
    settlementDate: '2026-04-15',
    contractSize: 5000,
    fillPercentage: 0,
    hedgePct: 10,
    requiredDeposit: 500,
    createdBy: 'Ama Mensah',
    createdAt: 'Yesterday, 3:00 PM',
  },
  {
    id: '5',
    commodityId: '1',
    contractType: 'firm',
    status: 'ACTIVE',
    buyerName: 'Cocoa Processing Co.',
    forwardPrice: 1200,
    settlementDate: '2026-06-01',
    contractSize: 8000,
    position: 'BUYER',
    fillPercentage: 75,
    hedgePct: 12,
    requiredDeposit: 960,
    createdBy: 'Kofi Asante',
    createdAt: 'Mar 18, 9:30 AM',
  },
  {
    id: '6',
    commodityId: '8',
    contractType: 'soft',
    status: 'PENDING',
    buyerName: 'Accra Rice Mills',
    forwardPrice: 600,
    settlementDate: '2026-05-20',
    contractSize: 3000,
    fillPercentage: 0,
    hedgePct: 8,
    requiredDeposit: 240,
    createdBy: 'Yaa Boateng',
    createdAt: 'Mar 19, 11:00 AM',
  },
  {
    id: '7',
    commodityId: '11',
    contractType: 'firm',
    status: 'ACTIVE',
    buyerName: 'Tema Constructions',
    forwardPrice: 3500,
    settlementDate: '2026-03-30',
    contractSize: 15000,
    position: 'SELLER',
    fillPercentage: 40,
    hedgePct: 10,
    requiredDeposit: 1500,
    createdBy: 'Kwesi Owusu',
    createdAt: 'Mar 17, 2:00 PM',
  },
  {
    id: '8',
    commodityId: '6',
    contractType: 'soft',
    status: 'PENDING',
    buyerName: 'Northern Agro Ltd.',
    forwardPrice: 950,
    settlementDate: '2026-07-10',
    contractSize: 4000,
    fillPercentage: 0,
    hedgePct: 10,
    requiredDeposit: 400,
    createdBy: 'Abena Tetteh',
    createdAt: 'Mar 20, 8:00 AM',
  },
];

export type ContractSeller = {
  id: string;
  name: string;
  quantity: number;
  contribution: number;
  status: ContractStatus;
};

export const allContractSellers: ContractSeller[] = [
  {
    id: '1',
    name: 'ABC Farms',
    quantity: 8000,
    contribution: 80,
    status: 'ACTIVE',
  },
  {
    id: '2',
    name: 'XYZ Farms',
    quantity: 1000,
    contribution: 10,
    status: 'PENDING',
  },
  {
    id: '3',
    name: 'JKL Farms',
    quantity: 1000,
    contribution: 10,
    status: 'EXPIRED',
  },
];

export type TransactionStatus = 'pending' | 'approved' | 'rejected';

export interface Vendor {
  id: string;
  name: string;
  yearSpend: string;
  monthSpend: string;
  category: string;
  contractStartDate?: string;
  contractEndDate?: string;
  defaultContact: string;
  status: 'active' | 'terminated';
}

export interface PurchaseOrder {
  id: string;
  owner: string;
  amountRequested: number;
  department: string;
  expenseCategory: string;
  status: TransactionStatus;
  vendorId?: string;
  approver?: string;
  isDraft?: boolean;
}

export interface Invoice {
  id: string;
  vendorId?: string;
  amountRequested: number;
  department: string;
  expenseCategory: string;
  owner?: string;
}

export interface Receipt {
  id: string;
  vendorId?: string;
  amountPaid: number;
  department: string;
  expenseCategory: string;
  owner?: string;
}

export const allVendors: Vendor[] = [
  {
    id: '1',
    name: 'Elk Consulting',
    yearSpend: 'GHS100000',
    monthSpend: 'GHS1000',
    category: 'Logistics',
    contractStartDate: '2026-01-01',
    contractEndDate: '2026-12-31',
    defaultContact: 'John Doe',
    status: 'active',
  },
  {
    id: '2',
    name: 'XYZ Farms',
    yearSpend: 'GHS100000',
    monthSpend: 'GHS1000',
    category: 'Agriculture',
    defaultContact: 'Jane Doe',
    status: 'terminated',
  },
];

export const allPurchaseOrders: PurchaseOrder[] = [
  {
    id: '1',
    owner: 'John Doe',
    amountRequested: 1000,
    department: 'Engineering',
    expenseCategory: 'Ground Transportation',
    status: 'pending',
  },
  {
    id: '2',
    owner: 'Jane Doe',
    amountRequested: 1000,
    department: 'Operations',
    expenseCategory: 'Shipping & Postage',
    status: 'pending',
    isDraft: true,
  },
  {
    id: '3',
    owner: 'John Doe',
    amountRequested: 1000,
    department: 'Operations',
    expenseCategory: 'Insurance',
    status: 'approved',
    isDraft: false,
  },
];

export const allInvoices: Invoice[] = [
  {
    id: '1',
    vendorId: '1',
    amountRequested: 1000,
    department: 'Engineering',
    expenseCategory: 'Ground Transportation',
  },
  {
    id: '2',
    vendorId: '2',
    amountRequested: 10000,
    department: 'Operations',
    expenseCategory: 'Shipping & Postage',
  },
  {
    id: '3',
    vendorId: '1',
    amountRequested: 10000,
    department: 'Operations',
    expenseCategory: 'Shipping & Postage',
  },
];

export const allReceipts: Receipt[] = [
  {
    id: '1',
    vendorId: '1',
    amountPaid: 1000,
    department: 'Engineering',
    expenseCategory: 'Ground Transportation',
  },
  {
    id: '2',
    vendorId: '2',
    amountPaid: 10000,
    department: 'Operations',
    expenseCategory: 'Shipping & Postage',
  },
  {
    id: '3',
    vendorId: '1',
    amountPaid: 10000,
    department: 'Operations',
    expenseCategory: 'Hardware',
  },
];

// ── Finance Mode (payment links + supplier payouts) ────────────────────────────
// UI-only fixtures. The operator collects local currency via a long-lived link and,
// on fulfilment, sends USDC to a supplier wallet (see docs/final/04-finance-mode.md).

export type PaymentRequestStatus =
  | 'open'
  | 'partially_paid'
  | 'fulfilled'
  | 'closed'
  | 'cancelled';

// One partial pay-in against a link. `usdcCredited` is what the per-payment rate
// lock converted the local amount into — that USDC is what funds the supplier leg.
export interface PaymentRequestPayment {
  id: string;
  amount: number; // in the request's target currency
  usdcCredited: number;
  provider: string;
  status: 'pending' | 'settled' | 'failed';
  settledAt?: string;
}

export type SupplierPayoutNetwork =
  | 'stellar'
  | 'ethereum'
  | 'base'
  | 'polygon'
  | 'arbitrum'
  | 'tron';

export type SupplierPayoutStatus =
  | 'not_started'
  | 'pending'
  | 'confirming'
  | 'completed'
  | 'held';

// The external-wallet USDC payout fired (manually, in v1) when a link is fulfilled.
export interface SupplierPayout {
  id: string;
  paymentRequestId: string;
  supplierName: string;
  amountUsdc: number;
  network: SupplierPayoutNetwork;
  address: string;
  memo?: string;
  status: SupplierPayoutStatus;
  initiatedAt?: string;
  confirmedAt?: string;
  txHash?: string; // destination-chain transaction, once sent
}

export interface PaymentRequest {
  id: string;
  slug: string; // shareable /pay/<slug> token
  title: string;
  customerName: string;
  targetAmount: number;
  targetCurrency: string;
  receivedAmount: number;
  status: PaymentRequestStatus;
  allowPartial: boolean;
  // When the link is fully paid: true → fire the supplier payout automatically;
  // false → the operator initiates it manually (doc §5, v1 default).
  autoSettle: boolean;
  // The operator's business name — what the payer sees on the public checkout
  // ("Payment to …"). Per-request so links can be operator-branded (doc §4).
  merchantName: string;
  createdBy: string;
  createdAt: string;
  expiresAt?: string;
  payments: PaymentRequestPayment[];
  payout?: SupplierPayout;
}

export const allPaymentRequests: PaymentRequest[] = [
  {
    id: 'pr_1',
    slug: 'inv-4421-customer-x',
    title: 'Invoice 4421 — Customer X',
    customerName: 'Customer X',
    targetAmount: 10000,
    targetCurrency: 'GHS',
    receivedAmount: 6500,
    status: 'partially_paid',
    allowPartial: true,
    autoSettle: false,
    merchantName: 'Adinkra Trading Co.',
    createdBy: 'Ama Mensah',
    createdAt: '2026-05-18',
    expiresAt: '2026-06-18',
    payments: [
      {
        id: 'prp_1',
        amount: 4000,
        usdcCredited: 256.41,
        provider: 'TransFi',
        status: 'settled',
        settledAt: '2026-05-18',
      },
      {
        id: 'prp_2',
        amount: 2500,
        usdcCredited: 159.74,
        provider: 'TransFi',
        status: 'settled',
        settledAt: '2026-05-21',
      },
    ],
    payout: {
      id: 'po_1',
      paymentRequestId: 'pr_1',
      supplierName: 'Shenzhen Hardware Co.',
      amountUsdc: 600,
      network: 'polygon',
      address: '0x8f2A...c41B',
      status: 'not_started',
    },
  },
  {
    id: 'pr_2',
    slug: 'shipment-deposit-acme',
    title: 'Shipment deposit — Acme Traders',
    customerName: 'Acme Traders',
    targetAmount: 25000,
    targetCurrency: 'GHS',
    receivedAmount: 25000,
    status: 'fulfilled',
    allowPartial: true,
    autoSettle: false,
    merchantName: 'Adinkra Trading Co.',
    createdBy: 'Ama Mensah',
    createdAt: '2026-05-10',
    payments: [
      {
        id: 'prp_3',
        amount: 25000,
        usdcCredited: 1602.56,
        provider: 'Bridge',
        status: 'settled',
        settledAt: '2026-05-12',
      },
    ],
    payout: {
      id: 'po_2',
      paymentRequestId: 'pr_2',
      supplierName: 'Guangzhou Textiles Ltd.',
      amountUsdc: 1500,
      network: 'stellar',
      address: 'GA7Q...XK9P',
      status: 'not_started',
    },
  },
  {
    id: 'pr_3',
    slug: 'consulting-retainer-may',
    title: 'Consulting retainer — May',
    customerName: 'Kofi Boateng',
    targetAmount: 5000,
    targetCurrency: 'GHS',
    receivedAmount: 0,
    status: 'open',
    allowPartial: false,
    autoSettle: true,
    merchantName: 'Adinkra Trading Co.',
    createdBy: 'Yaw Owusu',
    createdAt: '2026-05-23',
    payments: [],
  },
  {
    id: 'pr_4',
    slug: 'logistics-q2-northstar',
    title: 'Logistics Q2 — Northstar',
    customerName: 'Northstar Logistics',
    targetAmount: 18000,
    targetCurrency: 'GHS',
    receivedAmount: 18000,
    status: 'closed',
    allowPartial: true,
    autoSettle: true,
    merchantName: 'Adinkra Trading Co.',
    createdBy: 'Ama Mensah',
    createdAt: '2026-04-28',
    payments: [
      {
        id: 'prp_4',
        amount: 9000,
        usdcCredited: 576.92,
        provider: 'TransFi',
        status: 'settled',
        settledAt: '2026-04-29',
      },
      {
        id: 'prp_5',
        amount: 9000,
        usdcCredited: 574.13,
        provider: 'TransFi',
        status: 'settled',
        settledAt: '2026-05-02',
      },
    ],
    payout: {
      id: 'po_3',
      paymentRequestId: 'pr_4',
      supplierName: 'Hai Phong Freight',
      amountUsdc: 1100,
      network: 'tron',
      address: 'TJ9k...m2Qa',
      status: 'completed',
      initiatedAt: '2026-05-02',
      confirmedAt: '2026-05-03',
      txHash: '9a3f8c2e7b1d4a6f0c5e2b8d1f7a4c9e3b6d0a2f8c1e5b7d9a3f6c2e8b1d4a7c',
    },
  },
];

export const allSupplierPayouts: SupplierPayout[] = allPaymentRequests
  .map((request) => request.payout)
  .filter((payout): payout is SupplierPayout => payout != null);

// ── Cash balance (per-currency wallets) ────────────────────────────────────────
// The org can hold a local-currency balance (hedging/PM) and a USDC balance
// (Finance Mode collections) at once; the cash-balance page switches between them.

export interface CashBalance {
  currency: string;
  label: string;
  amount: number;
  isCrypto: boolean;
}

export const allCashBalances: CashBalance[] = [
  { currency: 'USDC', label: 'USD Coin', amount: 6410.26, isCrypto: true },
  { currency: 'GHS', label: 'Ghanaian Cedi', amount: 100000, isCrypto: false },
];

export type CashTransactionDirection = 'in' | 'out';

export interface CashTransaction {
  id: string;
  currency: string;
  description: string;
  amount: number; // positive magnitude; direction carries the sign
  direction: CashTransactionDirection;
  date: string;
}

export const allCashTransactions: CashTransaction[] = [
  {
    id: 'ct_1',
    currency: 'USDC',
    description: 'Collected — Invoice 4421 — Customer X',
    amount: 256.41,
    direction: 'in',
    date: '2026-05-18',
  },
  {
    id: 'ct_2',
    currency: 'USDC',
    description: 'Collected — Invoice 4421 — Customer X',
    amount: 159.74,
    direction: 'in',
    date: '2026-05-21',
  },
  {
    id: 'ct_3',
    currency: 'USDC',
    description: 'Payout — Hai Phong Freight',
    amount: 1100,
    direction: 'out',
    date: '2026-05-02',
  },
  {
    id: 'ct_4',
    currency: 'GHS',
    description: 'Deposit from bank',
    amount: 100000,
    direction: 'in',
    date: '2026-05-01',
  },
];

// ── Customers (unique by phone) ────────────────────────────────────────────────
// Tracked across payment links, invoices, and public-checkout payers. Phone is
// the durable identity (E.164); email is optional.

export interface Customer {
  id: string;
  name: string;
  phone: string; // E.164
  email?: string;
  createdAt: string;
}

export const allCustomers: Customer[] = [
  { id: 'cust_1', name: 'Customer X', phone: '+233241000001', createdAt: '2026-05-10' },
  {
    id: 'cust_2',
    name: 'Acme Traders',
    phone: '+233241000002',
    email: 'accounts@acmetraders.com',
    createdAt: '2026-05-08',
  },
  {
    id: 'cust_3',
    name: 'Kofi Boateng',
    phone: '+233241000003',
    email: 'kofi.boateng@gmail.com',
    createdAt: '2026-04-28',
  },
  { id: 'cust_4', name: 'Northstar Logistics', phone: '+233241000004', createdAt: '2026-04-20' },
];

// ── Invoicing (AR — invoices the operator issues to collect) ───────────────────
// An invoice is a billing document that, once finalized, is collected through the
// money layer (same engine as PaymentRequest). Online settlement → public /pay
// page; cash → the operator records payments manually.

export type InvoiceTemplate = 'standard' | 'spreadsheet' | 'continental' | 'compact';
export type SettlementKind = 'online' | 'cash';
export type InvoiceStatus = 'draft' | 'sent' | 'partially_paid' | 'paid' | 'void';

export interface InvoiceBranding {
  background: string;
  label: string;
  font: string;
}

// Org-level invoicing setup (from the wizard). Template/settlement here are
// defaults; each invoice can override them.
export interface InvoiceConfig {
  businessName: string;
  logoUrl?: string;
  template: InvoiceTemplate;
  branding: InvoiceBranding;
  defaultSettlement: SettlementKind;
  numberPrefix: string;
  nextNumber: string;
  autoNumber: boolean;
}

export const invoiceConfig: InvoiceConfig = {
  businessName: 'Adinkra Trading Co.',
  template: 'standard',
  branding: { background: '#ffffff', label: '#1a1a1a', font: '#1a1a1a' },
  defaultSettlement: 'online',
  numberPrefix: 'INV-',
  nextNumber: '000006',
  autoNumber: true,
};

export type ItemType = 'goods' | 'service';

export interface InvoiceLineItem {
  id: string;
  description: string;
  quantity: number;
  rate: number;
  taxRatePercent?: number;
  itemType?: ItemType; // defaults to goods
  unit?: string; // unit of measure for goods (e.g. Box, kg)
}

export interface SalesInvoice {
  id: string;
  number: string;
  slug: string; // public /pay/<slug>
  customerId: string;
  status: InvoiceStatus;
  template: InvoiceTemplate;
  settlement: SettlementKind;
  issueDate: string;
  dueDate: string;
  lineItems: InvoiceLineItem[];
  discountPercent: number;
  shippingCharge: number;
  adjustment: number;
  currency: string;
  notes?: string;
  terms?: string;
  receivedAmount: number; // collected so far (unified with the money-layer pay-in)
  createdBy: string;
  createdAt: string;
}

export const allSalesInvoices: SalesInvoice[] = [
  {
    id: 'inv_1',
    number: 'INV-000005',
    slug: 'inv-000005',
    customerId: 'cust_1',
    status: 'draft',
    template: 'standard',
    settlement: 'online',
    issueDate: '2026-05-25',
    dueDate: '2026-06-08',
    lineItems: [
      { id: 'li_1', description: 'Consulting — May retainer', quantity: 1, rate: 5000 },
    ],
    discountPercent: 0,
    shippingCharge: 0,
    adjustment: 0,
    currency: 'GHS',
    notes: 'Thanks for your business.',
    receivedAmount: 0,
    createdBy: 'Ama Mensah',
    createdAt: '2026-05-25',
  },
  {
    id: 'inv_2',
    number: 'INV-000004',
    slug: 'inv-000004',
    customerId: 'cust_2',
    status: 'partially_paid',
    template: 'continental',
    settlement: 'online',
    issueDate: '2026-05-18',
    dueDate: '2026-06-01',
    lineItems: [
      { id: 'li_2', description: 'Bag of cement (50kg)', quantity: 100, rate: 95, taxRatePercent: 15 },
      { id: 'li_3', description: 'Delivery to site', quantity: 1, rate: 1500 },
    ],
    discountPercent: 0,
    shippingCharge: 0,
    adjustment: 0,
    currency: 'GHS',
    notes: 'Thanks for your business.',
    receivedAmount: 6000,
    createdBy: 'Ama Mensah',
    createdAt: '2026-05-18',
  },
  {
    id: 'inv_3',
    number: 'INV-000003',
    slug: 'inv-000003',
    customerId: 'cust_3',
    status: 'paid',
    template: 'compact',
    settlement: 'cash',
    issueDate: '2026-05-02',
    dueDate: '2026-05-16',
    lineItems: [
      { id: 'li_4', description: 'Website design — milestone 1', quantity: 1, rate: 8000 },
    ],
    discountPercent: 10,
    shippingCharge: 0,
    adjustment: 0,
    currency: 'GHS',
    receivedAmount: 7200,
    createdBy: 'Yaw Owusu',
    createdAt: '2026-05-02',
  },
  {
    id: 'inv_4',
    number: 'INV-000002',
    slug: 'inv-000002',
    customerId: 'cust_4',
    status: 'sent',
    template: 'spreadsheet',
    settlement: 'online',
    issueDate: '2026-05-20',
    dueDate: '2026-06-19',
    lineItems: [
      { id: 'li_5', description: 'Freight forwarding — Q2', quantity: 1, rate: 18000, taxRatePercent: 15 },
    ],
    discountPercent: 0,
    shippingCharge: 250,
    adjustment: 0,
    currency: 'GHS',
    notes: 'Net 30. Thanks for your business.',
    receivedAmount: 0,
    createdBy: 'Ama Mensah',
    createdAt: '2026-05-20',
  },
  {
    id: 'inv_5',
    number: 'INV-000001',
    slug: 'inv-000001',
    customerId: 'cust_2',
    status: 'void',
    template: 'standard',
    settlement: 'online',
    issueDate: '2026-04-30',
    dueDate: '2026-05-14',
    lineItems: [
      { id: 'li_6', description: 'Duplicate order — voided', quantity: 1, rate: 3000 },
    ],
    discountPercent: 0,
    shippingCharge: 0,
    adjustment: 0,
    currency: 'GHS',
    receivedAmount: 0,
    createdBy: 'Ama Mensah',
    createdAt: '2026-04-30',
  },
];

// ── Suppliers (org-wide directory) ─────────────────────────────────────────────
// Tracked like customers; optional payment info autofills the payment-link builder.

export interface Supplier {
  id: string;
  name: string;
  phone?: string;
  email?: string;
  network?: SupplierPayoutNetwork;
  walletAddress?: string;
  memo?: string;
  createdAt: string;
}

export const allSuppliers: Supplier[] = [
  {
    id: 'sup_1',
    name: 'Shenzhen Hardware Co.',
    email: 'sales@szhardware.cn',
    network: 'polygon',
    walletAddress: '0x8f2A...c41B',
    createdAt: '2026-04-10',
  },
  {
    id: 'sup_2',
    name: 'Guangzhou Textiles Ltd.',
    email: 'orders@gztextiles.cn',
    network: 'stellar',
    walletAddress: 'GA7Q...XK9P',
    memo: '8842113',
    createdAt: '2026-04-12',
  },
  {
    id: 'sup_3',
    name: 'Hai Phong Freight',
    network: 'tron',
    walletAddress: 'TJ9k...m2Qa',
    createdAt: '2026-04-15',
  },
  { id: 'sup_4', name: 'Accra Packaging', phone: '+233241555010', createdAt: '2026-05-01' },
];

// Units of measure for goods line items.
export const ITEM_UNITS = [
  'Box',
  'cm',
  'dz',
  'ft',
  'g',
  'in',
  'kg',
  'km',
  'lb',
  'liters',
  'mg',
  'ml',
  'm',
  'pcs',
] as const;

// Top-level merchandise classification, synthesized from the WCO Harmonized
// System sections and common B2B trade-marketplace taxonomies — broad enough to
// place any item, granular enough to be useful for filtering and reporting.
export const MERCHANDISE_CATEGORIES = [
  'Live animals & livestock',
  'Fresh produce (fruits & vegetables)',
  'Grains, cereals & legumes',
  'Nuts & seeds',
  'Coffee, tea, cocoa & spices',
  'Oils, fats & extracts',
  'Processed & packaged foods',
  'Beverages',
  'Seafood & fish products',
  'Animal feed & fodder',
  'Tobacco & related products',
  'Minerals, ores & mining',
  'Metals & metal products',
  'Fuels & energy products',
  'Chemicals & agrochemicals',
  'Plastics & rubber',
  'Pharmaceuticals & medical supplies',
  'Cosmetics & personal care',
  'Textiles, yarn & fabrics',
  'Apparel & accessories',
  'Leather & footwear',
  'Wood, timber & products',
  'Paper, pulp & packaging',
  'Construction & building materials',
  'Furniture & furnishings',
  'Machinery & industrial equipment',
  'Agricultural machinery & equipment',
  'Electronics & electrical equipment',
  'Automotive & vehicle parts',
  'Tools & hardware',
  'Household & consumer goods',
  'Handicrafts & artisanal goods',
  'Other',
] as const;
